import { com } from '@eidu/web'
import { Card, Group, iconSizes, Stack, Text } from '@common/ui'
import { IconTrash } from '@common/ui/icons'
import EntityTypeField from '../../pages/permission/path/EntityTypeField'
import ConfirmationDialog from '../layout/ConfirmationDialog'
import ComplexPathField from './ComplexPathField'
import useRenderablePaths from '../misc/useRenderablePaths'
import EntityPath = com.eidu.entity.path.EntityPath
import EntityType = com.eidu.entity.type.EntityType
import SemanticLinkId = com.eidu.entity.analytics.SemanticLinkId
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import FieldType = com.eidu.entity.field.FieldType

type SemanticLinkItemProps = {
  linkId: SemanticLinkId
  path: EntityPath
  entityTypeId: EntityTypeId
  entityTypes: readonly EntityType[]
  fieldType: FieldType
  onDelete?: (semanticLinkId: SemanticLinkId) => Promise<void>
}

const SemanticLinkItem = ({ linkId, path, entityTypes, entityTypeId, fieldType, onDelete }: SemanticLinkItemProps) => {
  const edges = path?.edges.asJsReadonlyArrayView()
  const lastEdge = edges.at(-1)
  const targetTypeId = lastEdge?.nextType

  const targetType = targetTypeId && entityTypes.find(({ id }) => id.equals(targetTypeId))

  const renderablePaths = useRenderablePaths(entityTypeId, targetType, entityTypes)

  return (
    <Card key={linkId.toString()} p={0} data-testid="semantic-card">
      <Group justify="space-between" align="center" wrap="nowrap">
        {targetType ? (
          <Stack gap="md" p="md">
            <EntityTypeField
              entityTypeId={targetType.id}
              onChange={() => {}}
              types={entityTypes}
              label="Target type"
              disabled
            />
            <ComplexPathField
              entityTypeId={entityTypeId}
              targetType={targetType}
              selectedPath={path}
              setSelectedPath={() => {}}
              renderablePaths={renderablePaths}
              fieldType={fieldType}
              disabled
            />
          </Stack>
        ) : (
          <Text c="negative" p={8}>
            The configuration for this semantic link is not available. Please delete and re-create or contact your admin
          </Text>
        )}
        {onDelete && (
          <ConfirmationDialog
            title="Are you sure you want to delete this link? This action cannot be undone."
            content={<IconTrash size={iconSizes.sm} stroke={1.5} />}
            onConfirm={() => onDelete(linkId)}
            triggerTestId="delete-semantic-link"
          />
        )}
      </Group>
    </Card>
  )
}

export default SemanticLinkItem
